import { Controller } from "@hotwired/stimulus";
import { useListen } from "hb/insights/use_listen";

export default class extends Controller {
  connect() {
    useListen(this);
  }

  updateAxes({ params: { axis }, target }) {
    const parent = target.closest(".field-group-item");
    this.emitWindow("vis:groupParamChange", {
      name: parent.dataset.fieldGroupName,
      data: {
        axis: axis === "left" ? null : axis,
      },
    });
  }

  updateColor({ target }) {
    const parent = target.closest(".field-group-item");
    this.emitWindow("vis:groupParamChange", {
      name: parent.dataset.fieldGroupName,
      data: {
        color: target.value,
      },
    });
  }
}
